// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/resource_unit.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Enum for supported units in resource specifications.
 *
 * @generated from enum ai.h2o.deploy.ResourceUnit
 */
export const ResourceUnit = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.deploy.ResourceUnit",
  [
    {no: 0, name: "RESOURCE_UNIT_UNSPECIFIED"},
    {no: 1, name: "CORES"},
    {no: 2, name: "MILLICORES"},
    {no: 3, name: "MIB"},
    {no: 4, name: "GIB"},
  ],
);

